import React from 'react';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { useRouteParams } from '../../hooks/useRouteParams';

interface Props {
  onClose(): void;
}

export const CancelModal: React.FC<Props> = ({ onClose }) => {
  const { clientId } = useRouteParams();

  return (
    <Modal isOpen onRequestClose={onClose}>
      <ModalHeader variant="warning">Cancel Application</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        Are you sure you want to cancel the new account application? Any progress will be lost, but
        you can easily restart later.
      </ModalBody>

      <ModalFooter>
        <Button
          variant="secondary"
          onClick={() => {
            ADV.util.Router.go2('AutoAccountWorkflow', { clientId });
          }}
        >
          Cancel Application
        </Button>

        <Button ml="12" onClick={onClose}>
          Continue
        </Button>
      </ModalFooter>
    </Modal>
  );
};
